import { render, staticRenderFns } from "./approvalMany.vue?vue&type=template&id=f698306c&scoped=true"
import script from "./approvalMany.vue?vue&type=script&lang=ts"
export * from "./approvalMany.vue?vue&type=script&lang=ts"
import style0 from "./approvalMany.vue?vue&type=style&index=0&id=f698306c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f698306c",
  null
  
)

export default component.exports